import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IFoodGroupIngredient} from '../../models/food-group';

@Component({
  selector: 'app-card-ingredient',
  templateUrl: './card-ingredient.component.html',
  styleUrls: ['./card-ingredient.component.scss']
})
export class CardIngredientComponent implements OnInit {
  @Input() ingredient: Partial<IFoodGroupIngredient>;
  @Input() color: string;
  @Input() editing: boolean;
  @Output() modify: EventEmitter<boolean> = new EventEmitter();
  @Output() delete: EventEmitter<boolean> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Emite al componente padre cuando se quiere modificar un ingrediente.
   */
  onEmitEditIngredient(): void {
    this.modify.emit(true);
  }

  /**
   * Emite al componente padre cuando se quiere eliminar un ingrediente.
   */
  onEmitRemoveIngredient(): void {
    this.delete.emit(true);
  }

}
